import { z } from 'my-zod'

export const SalesQuoteSeasonTypeEnum = z
  .enum(['IMX', 'SLG', 'MARINE', 'ORV', 'ORV_PEAK', 'ATV', 'SNO', 'SNO_PERFORMANCE', 'CUSTOM'])
  .setEnumLabels({
    IMX: 'IMX',
    SLG: 'SLG',
    MARINE: 'Marine',
    ORV: 'ORV',
    ORV_PEAK: 'ORV Peak',
    ATV: 'ATV',
    SNO: 'SNO',
    SNO_PERFORMANCE: 'SNO Performance',
    CUSTOM: 'Custom'
  })
export type SalesQuoteSeasonType = z.infer<typeof SalesQuoteSeasonTypeEnum>

export const QuoteSeasonType = SalesQuoteSeasonTypeEnum.Values
export const SalesQuoteSeasonTypeOptions = Object.values(QuoteSeasonType)
export const SalesQuoteSeasonTypeLabels = SalesQuoteSeasonTypeEnum.enumLabels
